var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container"},[_c('h1',{staticClass:"text__center margin__md"},[_vm._v("Admin")]),_c('Graphs'),_c('Orders'),_c('Processes'),_c('QuickSearch'),_c('Other')],1)}
var staticRenderFns = []

export { render, staticRenderFns }